<div class="bc-search-box bc-panel" *ngIf="!isLoading">
  <!-- Keyword Search field -->
  <div class="bc-search-field-wrapper">
    <div class="bc-search-query">
      <svg-icon icon="magnifier"></svg-icon>
      <input matInput type="text" class="bc-query-field" [(ngModel)]="searchQuery"
             placeholder="{{ 'bcSearchBox.searchPlaceholder' | translate }}"/>
      <svg-icon icon="x" *ngIf="searchQuery" (click)="searchQuery=''"></svg-icon>
    </div>
  </div>

  <div class="bc-search-field-wrapper">
    <h2 class="bc-sidenav-title">{{ 'bcSearchBox.dateRangeSelect' | translate }}</h2>
    <!-- Date range select dropdown -->
    <div class="btn-group bc-search-date-range-list"
         ngbDropdown
         (click)="toggleDateDropdown()"
         [attr.data-automation-id]="'bc-search-date-range-dropdown'">
      <button id="bc-search-date-filter"
              class="btn bc-search-dropdown-button"
              ngbDropdownToggle
              [attr.data-automation-id]="'bc-search-date-range-dropdown-filter-button'">
        <svg-icon icon="{{ isDateDropdownCollapsed ? 'arrow-down' : 'arrow-up' }}"></svg-icon>
        <span>{{ selectedDate?.text | translate }}</span>
      </button>
      <ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="bc-search-date-filter">
        <li ngbDropdownItem *ngFor="let date of dateRangeItems">
          <a (click)="searchDateChanged(date)"
             class="bc-search-date-item dropdown-header"
             [ngClass]="{'bc-search-date-selected': selectedDate?.id === date.id}">
            <div>{{ date.text | translate }}</div>
            <span>{{ date.readableStartDate }}</span>
            <span *ngIf="date.id !== 1"> - {{ date.valueEnd ? date.readableEndDate : 'bcSearchBox.today' | translate }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="bc-search-field-wrapper">
    <h2 class="bc-sidenav-title">{{ 'bcSearchBox.serviceTypeSelect' | translate }}</h2>
    <app-dropdown [dropdownId]="'bc-service-type-filter'" [items]="serviceTypes" (selectedItemChange)="serviceTypeChanged($event)" [shouldTranslate]="true"></app-dropdown>
  </div>

  <div *ngIf="operators" class="bc-search-field-wrapper bc-search-list-wrapper">
    <h2 class="bc-sidenav-title">{{ 'bcSearchBox.operatorSelect' | translate }}</h2>
    <app-dropdown [dropdownId]="'bc-service-operator-filter'" [items]="operators" (selectedItemChange)="operatorChanged($event)" [shouldTranslate]="true"></app-dropdown>
  </div>

  <div *ngIf="departments" class="bc-search-field-wrapper bc-search-list-wrapper">
    <h2 class="bc-sidenav-title">{{ 'bcSearchBox.departmentSelect' | translate }}</h2>
    <app-dropdown [dropdownId]="'bc-service-department-filter'" [items]="departments" (selectedItemChange)="departmentChanged($event)" [shouldTranslate]="true"></app-dropdown>
  </div>

  <div class="bc-search-field-wrapper">
    <button class="btn btn-dark btn-block js-search-button"
            [disabled]="!isSearchEnabled()"
            (click)="search()"
            [attr.data-automation-id]="'bc-search-button'">{{ 'bcSearchBox.searchButton' | translate }}</button>
  </div>
</div>

<app-loading *ngIf="isLoading"></app-loading>
